import React, { useContext } from 'react'
import {
    FaArrowAltCircleUp,
    FaRegArrowAltCircleUp,
    FaSlidersH,
    FaThList,
} from 'react-icons/fa'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { IconTooltip as Tooltip } from '../../../elem/Tooltip'
import CollapseButton from '../../../elem/list/CollapseButton'
import ExpandButton from '../../../elem/list/ExpandButton'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'

export default ({
    filterExpanded,
    toggleFilter,
    togglePromotedRecords,
    promotedRecords,
    setCollapsed,
    isCollapsed,
}) => {
    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <PanelHeader extraClass={'pressurePanelHeader'}>
            <div className="panelHeaderText">Pressure-Volume Explorer</div>
            <div className="panelHeaderControls">
                <div className="panelHeaderIconWrapper">
                    {!filterExpanded && (
                        <div
                            className="panelHeaderIconDiv"
                            data-tip={`${
                                promotedRecords
                                    ? `Do not promote Selected Records`
                                    : `Promote Selected Records`
                            }`}
                            data-for={`pressure-promoted-records-toggle-${promotedRecords}`}
                            onClick={() =>
                                togglePromotedRecords(!promotedRecords, 'Pressure')
                            }
                        >
                            {promotedRecords ? (
                                <FaArrowAltCircleUp />
                            ) : (
                                <FaRegArrowAltCircleUp />
                            )}
                            <Tooltip
                                id={`pressure-promoted-records-toggle-${promotedRecords}`}
                            />
                        </div>
                    )}
                    <div
                        className="panelHeaderIconDiv"
                        data-tip={`${
                            filterExpanded
                                ? `View Pressure-Volume List`
                                : `View Pressure-Volume Filter`
                        }`}
                        data-for={`pressure-view-toggle-${filterExpanded}`}
                        onClick={() => toggleFilter(!filterExpanded)}
                    >
                        {filterExpanded ? <FaThList /> : <FaSlidersH />}
                        <Tooltip id={`pressure-view-toggle-${filterExpanded}`} />
                    </div>
                    {isExpanded ? null : (
                        <CollapseButton
                            name={`pressure-list`}
                            isCollapsed={isCollapsed}
                            setIsCollapsed={setCollapsed}
                        />
                    )}
                    <ExpandButton
                        name={`pressure-list`}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}
